import type { ProductSelectOption } from '../constants/product-select'

export function filterNamedProducts<T extends { name: string }>(
  products: T[],
  query: string,
): T[] {
  const needle = query.trim().toLowerCase()
  if (!needle) return products
  return products.filter((product) => product.name.toLowerCase().includes(needle))
}

export function mergeSelectedIds(current: string[], adding: string[]): string[] {
  const next = new Set(current)
  for (const id of adding) next.add(id)
  return [...next]
}

export function removeSelectedIds(current: string[], removing: string[]): string[] {
  const drop = new Set(removing)
  return current.filter((id) => !drop.has(id))
}

export function areAllIdsSelected(
  visibleIds: string[],
  selectedIds: string[],
): boolean {
  if (visibleIds.length === 0) return false
  const selected = new Set(selectedIds)
  return visibleIds.every((id) => selected.has(id))
}

export function selectedNamedProducts<T extends ProductSelectOption>(
  products: T[],
  selectedIds: string[],
): T[] {
  const byId = new Map(products.map((product) => [product.id, product]))
  return selectedIds.flatMap((id) => {
    const product = byId.get(id)
    return product ? [product] : []
  })
}
